import { getClient } from './client'
import { PublicKey, CardTokenizeParams, TokenId, Token } from './types'

export * from './types'

let __PUBLIC_KEY__: string | null = null

export const setPublicKey = (publicKey: PublicKey) =>
  (__PUBLIC_KEY__ = publicKey)

export default async () => {
  if (!__PUBLIC_KEY__) throw new Error('PayJP public key not set')

  const client = await getClient(__PUBLIC_KEY__)

  return {
    getPublicKey: (): PublicKey => client.getPublicKey(),
    elements: (options?: { locale: 'ja' | 'en' }) => client.elements(options),
    createToken: (
      elements: CardTokenizeParams['elements'],
      options?: { card: { name: CardTokenizeParams['name'] } }
    ): Promise<Token> => client.createToken(elements, options),
    getToken: (tokenId: TokenId): Promise<Token> =>
      new Promise((resolve, reject) =>
        client.getToken(tokenId, (status: number, response: Token) => {
          if (status === 200) {
            resolve(response)
          } else {
            reject(response)
          }
        })
      ),
    // TODO: retrieveAvailability
  }
}
